import { FileText, Phone, Search, ClipboardCheck } from "lucide-react";
import { AnimatedSection } from "@/components/AnimatedSection";

const ProcessSteps = () => {
  const steps = [
    {
      icon: FileText,
      number: "1",
      title: "Completa el Formulario",
      description: "Ingresa los datos de tu local en 2 minutos"
    },
    {
      icon: Phone,
      number: "2",
      title: "Te Contactamos en 24hrs",
      description: "Coordinamos visita según tu disponibilidad"
    },
    {
      icon: Search,
      number: "3",
      title: "Levantamiento Técnico",
      description: "Nuestro equipo revisa tu instalación eléctrica"
    },
    {
      icon: ClipboardCheck,
      number: "4",
      title: "Recibe tu Informe",
      description: "Te entregamos diagnóstico y cotización detallada"
    }
  ];

  return (
    <section id="proceso" className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-dark-section via-dark-section/95 to-industrial-gray">
        <div className="absolute top-20 left-10 w-96 h-96 bg-primary/30 rounded-full blur-3xl animate-liquid-blob opacity-20" />
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <AnimatedSection animation="fade-in">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-white text-center mb-4">
            Así de Fácil es Cuidar tu Negocio
          </h2>
          <p className="text-lg text-white/70 text-center mb-12">
            Todo el proceso toma máximo <span className="text-primary font-bold">3 días hábiles</span>
          </p>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {steps.map((step, index) => (
            <AnimatedSection
              key={index}
              animation="slide-up"
              delay={index * 100}
            >
              <div className="relative backdrop-blur-xl bg-white/10 border-2 border-white/20 rounded-3xl p-8 pt-12 hover:bg-white/15 transition-all duration-300 hover:scale-105 text-center h-full flex flex-col">
                <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-primary text-white font-bold text-xl flex items-center justify-center shadow-liquid-lg border-4 border-dark-section">
                  {step.number}
                </div>
                
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary/30 to-primary/10 border-2 border-primary/40 flex items-center justify-center mb-6 mx-auto mt-4 shadow-liquid-lg">
                  <step.icon className="w-8 h-8 text-primary" />
                </div>
                
                <h3 className="text-xl font-montserrat font-bold text-white mb-3">
                  {step.title}
                </h3>
                
                <p className="text-white/70 text-sm flex-grow">
                  {step.description}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
